<template>
  <div>
    <span style="font-weight: bold;margin-right: 20px;">订单QA</span>
    <el-button size="mini" @click="updateQuestionAnswer">修改</el-button>
    <div style="white-space: pre-line;margin: 20px 0;">{{questionAnswer}}</div>
    <span style="font-weight: bold;margin-right: 20px;">平台协议</span>
    <el-button size="mini" @click="updateAgreement">修改</el-button>
    <div style="white-space: pre-line;margin: 20px 0;">{{agreement}}</div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-input
        type="textarea"
        :rows="10"
        :placeholder="'请输入'+title+'内容'"
        v-model="content">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitContent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../utils/utils'
    export default {
      name: "agreement-setting",
      data(){
        return{
          content:"",
          dialogVisible:false,
          questionAnswer:"",
          agreement:"",
          type:null,
          title:""
        }
      },
      created(){
        this.getQuestionAnswer()
        this.getAgreement()
      },
      methods:{
        getQuestionAnswer(){
          utils.axiosMethods({
            method:"GET",
            url:"/api/shop/queryQuestionAnswer",
            callback:(res => {
              if(res.data.obj){
                this.questionAnswer = res.data.obj.content
              }
            })
          })
        },
        getAgreement(){
          utils.axiosMethods({
            method:"GET",
            url:"/api/shop/queryAgreement",
            callback:(res => {
              if(res.data.obj){
                this.agreement = res.data.obj.content
              }
            })
          })
        },
        updateQuestionAnswer(){
          this.dialogVisible = true;
          this.content = this.questionAnswer;
          this.type = 1;
          this.title = "订单QA"
        },
        submitContent(){
          let formData = new FormData();
          formData.append("content",this.content);
          utils.axiosMethods({
            method:"POST",
            url:this.type == 1 ? "/api/shop/updateQuestionAnswer":"/api/shop/updateAgreement",
            data:formData,
            callback:(res => {
              if(this.type == 1){
                this.questionAnswer = this.content
              }else{
                this.agreement = this.content
              }
              this.handleClose()
            })
          })
        },
        handleClose(){
          this.dialogVisible = false;
          this.content = "";
        },
        updateAgreement(){
          this.dialogVisible = true;
          this.content = this.agreement;
          this.type = 2;
          this.title = "平台协议"
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/agreementSetting.vue